import { QueryKey } from "@tanstack/react-query";
import { QUERY_CACHE_PERIOD } from "../../constants/queryConstants";
import { ServicePath } from "../../constants/apiConstants";

import { useFetchQuery, getFetchQuery } from "../core/rest/useFetchQuery";
import { Session } from "./session.types";

const QUERY_KEY = ["session"] as const satisfies QueryKey;

export function getSessionQuery(getAccessToken?: () => Promise<string>) {
  return getFetchQuery<Session>({
    queryKey: QUERY_KEY,
    url: ServicePath.SessionV1,
    getAccessToken,
    options: { staleTime: QUERY_CACHE_PERIOD.SHORT },
  });
}

export function useGetSession() {
  return useFetchQuery<Session>({
    queryKey: QUERY_KEY,
    url: ServicePath.SessionV1,
    options: { staleTime: QUERY_CACHE_PERIOD.SHORT },
  });
}
